module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.5990/img/provider-signup/community-creators-image.png"